import { useDemoStore, type Locale } from "./store";
import { useCallback } from "react";

// Source-message keys are stable UI message IDs, never API field names or payloads.
export const uiMessages = {
  "已连接到媒体服务，等待对方开始媒体。": ["Connected to media. Waiting for the other endpoint to start media.", "已连接到媒体服务，等待对方开始媒体。"],
  "媒体已连接，等待远端媒体": ["Media connected; waiting for remote media.", "媒体已连接，等待远端媒体"],
  "正在连接媒体": ["Connecting media…", "正在连接媒体"],
  "已收到远端媒体": ["Remote media received.", "已收到远端媒体"],
  "已收到远端音频": ["Remote audio received.", "已收到远端音频"],
  "点击开始会话，浏览器会请求媒体权限。": ["Start the session; the browser will request media permissions.", "点击开始会话，浏览器会请求媒体权限。"],
  "先呼叫设备或加入会议，再开始音视频。": ["Call an endpoint or join a meeting before starting media.", "先呼叫设备或加入会议，再开始音视频。"],
  "等待对方开始媒体。": ["Waiting for the other endpoint to start media.", "等待对方开始媒体。"],
  "正在呼叫，等待接听": ["Ringing", "正在呼叫，等待接听"],
  "已接听，请开始通话媒体": ["Accepted; media starts automatically. If it fails, retry below.", "已接听，自动连接音视频；失败后可在下方重试"],
  "已接听，正在连接媒体": ["Accepted; connecting media.", "已接听，正在连接媒体"],
  "媒体已连接": ["Media connected", "媒体已连接"],
  "通话已结束，媒体清理待重试": ["Call ended; media cleanup will retry.", "通话已结束，媒体清理待重试"],
  "对方已拒绝通话": ["Call declined", "对方已拒绝通话"],
  "通话已结束": ["Call ended", "通话已结束"],
  "通话超时或对方已离线": ["Call timed out or disconnected", "通话超时或对方已离线"],
  "双向通话": ["Direct call", "双向通话"],
  "可选择本人有权访问的空间和设备发起呼叫，无需创建会议。交互设备接听后开始媒体；任一方挂断即结束双方通话。浏览器 Endpoint 由创建它的已登录浏览器会话接听。": ["Call a device in a space you can access; no meeting is needed. Interactive devices start media after answering. Either participant can end the call. A browser Endpoint is answered in the signed-in browser session that created it.", "可选择本人有权访问的空间和设备发起呼叫，无需创建会议。交互设备接听后开始媒体；任一方挂断即结束双方通话。浏览器 Endpoint 由创建它的已登录浏览器会话接听。"],
  "呼叫空间": ["Call space", "呼叫空间"],
  "正在加载设备": ["Loading devices…", "正在加载设备"],
  "刷新设备": ["Refresh devices", "刷新设备"],
  "重试媒体清理": ["Retry media cleanup", "重试媒体清理"],
  "呼叫对象": ["Call target", "呼叫对象"],
  "此浏览器的 Endpoint ID": ["This browser's Endpoint ID", "此浏览器的 Endpoint ID"],
  "已选呼叫对象的完整 Endpoint ID": ["Full Endpoint ID of selected target", "已选呼叫对象的完整 Endpoint ID"],
  "选择设备或 App": ["Choose device or App", "选择设备或 App"],
  "（离线）": [" (offline)", "（离线）"],
  "呼叫": ["Call", "呼叫"],
  "请先退出或结束当前会议": ["Leave or end the current meeting first", "请先退出或结束当前会议"],
  "收到来电": ["Incoming call", "收到来电"],
  "接听": ["Accept", "接听"],
  "拒绝": ["Decline", "拒绝"],
  "挂断": ["Hang up", "挂断"],
  "房间和会话已刷新": ["Rooms and sessions refreshed", "房间和会话已刷新"],
  "Publication 已创建": ["Publication created", "媒体发布已创建"],
  "Track 列表已刷新": ["Tracks refreshed", "轨道列表已刷新"],
  "Subscription 已创建": ["Subscription created", "订阅已创建"],
  "媒体资源": ["Media resources", "媒体资源"],
  "验证 Publication、Track、Subscription 和 DataChannel；真实媒体权限仍在直播页操作。": ["Manage publications, tracks, subscriptions and messages. Start live media in Live.", "管理媒体发布、轨道、订阅和实时消息。实际音视频连接请在直播页操作。"],
  "刷新房间和会话": ["Refresh rooms and sessions", "刷新房间和会话"],
  "Publication": ["Publication", "媒体发布"],
  "Room": ["Room", "房间"],
  "Publication Room": ["Publication room", "发布房间"],
  "选择房间": ["Choose a room", "选择房间"],
  "Endpoint ID": ["Endpoint ID", "设备 ID"],
  "复制 ID": ["Copy ID", "复制 ID"],
  "已复制 Endpoint ID": ["Endpoint ID copied", "已复制 Endpoint ID"],
  "创建 Publication": ["Create publication", "创建媒体发布"],
  "Track 与 Subscription": ["Tracks and subscriptions", "轨道与订阅"],
  "Publication ID": ["Publication ID", "发布 ID"],
  "Session": ["Session", "会话"],
  "Subscription Session": ["Subscription session", "订阅会话"],
  "选择会话": ["Choose a session", "选择会话"],
  "刷新 Tracks": ["Refresh tracks", "刷新轨道"],
  "创建 Subscription": ["Create subscription", "创建订阅"],
  "Track ID": ["Track ID", "轨道 ID"],
  "Kind": ["Kind", "类别"],
  "Codec": ["Codec", "编码"],
  "State": ["State", "状态"],
  "暂无 Track。": ["No tracks loaded.", "暂无轨道"],
  "请先在直播页开始并连接会话": ["Start and connect a session in Live first", "请先在直播页开始并连接会话"],
  "消息已发送": ["Message sent", "消息已发送"],
  "实时消息": ["Real-time messages", "实时消息"],
  "Topic": ["Topic", "消息主题"],
  "消息": ["Message", "消息"],
  "可靠传输": ["Reliable delivery", "可靠传输"],
  "发送消息": ["Send message", "发送消息"],
  "Endpoint 归属已刷新": ["Device spaces refreshed", "设备归属已刷新"],
  "Domain membership 已添加": ["Space membership added", "空间归属已添加"],
  "Domain membership 已移除": ["Space membership removed", "空间归属已移除"],
  "Endpoint 已转让": ["Device transferred", "设备已转让"],
  "Endpoint 归属与关系": ["Device spaces and relationships", "设备归属与关系"],
  "刷新归属": ["Refresh membership", "刷新归属"],
  "尚未读取": ["Not loaded", "尚未读取"],
  "目标 Domain": ["Target space ID", "目标空间 ID"],
  "Expected version": ["Expected version", "预期版本"],
  "添加 membership": ["Add membership", "添加空间归属"],
  "移除 membership": ["Remove membership", "移除空间归属"],
  "转让源 Domain": ["Source space ID", "转让源空间 ID"],
  "转让 Endpoint": ["Transfer device", "转让设备"],
  "reported 状态已提交": ["Reported state submitted", "设备上报状态已提交"],
  "命令状态已提交": ["Command state submitted", "命令状态已提交"],
  "请输入完整 Endpoint ID 进行确认": ["Enter the complete device ID to confirm", "请输入完整设备 ID 进行确认"],
  "抹掉数据": ["Wipe data", "抹掉数据"],
  "恢复出厂设置": ["Factory reset", "恢复出厂设置"],
  "设备操作已请求；成功仅代表设备回执，不代表平台数据已清理": ["Operation requested. Success confirms the device acknowledgement; platform copies are not cleared.", "设备操作已请求；成功仅代表设备回执，不代表平台数据已清理"],
  "仅在本地演示成功回执，不发送请求，不修改服务端操作状态。继续？": ["Demonstrate an acknowledgement locally without sending a request or changing server state. Continue?", "仅在本地演示成功回执，不发送请求，不修改服务端操作状态。继续？"],
  "设备操作与回执": ["Device operations and acknowledgements", "设备操作与回执"],
  "Shadow reported": ["Reported device state", "设备上报状态"],
  "最近响应版本": ["Latest response version", "最近响应版本"],
  "写入前自动读取对应资源版本": ["Read the resource version automatically before writing", "写入前自动读取对应资源版本"],
  "提交 reported": ["Submit reported state", "提交上报状态"],
  "Command ID": ["Command ID", "命令 ID"],
  "Command state": ["Command state", "命令状态"],
  "sent": ["Sent", "已发送"],
  "executing": ["Executing", "执行中"],
  "succeeded": ["Succeeded", "已成功"],
  "failed": ["Failed", "已失败"],
  "expired": ["Expired", "已过期"],
  "unknown": ["Unknown", "未知"],
  "requested": ["Requested", "已请求"],
  "pending": ["Pending", "待处理"],
  "accepted": ["Accepted", "已接受"],
  "declined": ["Declined", "已拒绝"],
  "revoked": ["Revoked", "已撤销"],
  "active": ["Active", "正常"],
  "disabled": ["Disabled", "已停用"],
  "online": ["Online", "在线"],
  "offline": ["Offline", "离线"],
  "idle": ["Idle", "未开始"],
  "loading": ["Loading", "加载中"],
  "planned": ["Planned", "已计划"],
  "running": ["Running", "运行中"],
  "completed": ["Completed", "已完成"],
  "stopped": ["Stopped", "已停止"],
  "closed": ["Closed", "已关闭"],
  "connected": ["Connected", "已连接"],
  "connecting": ["Connecting", "连接中"],
  "reconnecting": ["Reconnecting", "重新连接中"],
  "disconnected": ["Disconnected", "已断开"],
  "ready": ["Ready", "已就绪"],
  "uploaded": ["Uploaded", "已上传"],
  "available": ["Available", "可用"],
  "deleted": ["Deleted", "已删除"],
  "uploading": ["Uploading", "上传中"],
  "audio": ["Audio", "音频"],
  "video": ["Video", "视频"],
  "web": ["Web browser", "网页浏览器"],
  "browser": ["Browser", "浏览器"],
  "viewer": ["Viewer", "查看者"],
  "editor": ["Editor", "编辑者"],
  "operator": ["Operator", "操作员"],
  "admin": ["Administrator", "管理员"],
  "guest": ["Guest", "访客"],
  "提交命令回执": ["Submit command acknowledgement", "提交命令回执"],
  "抹掉数据和恢复出厂设置是破坏性设备能力。请输入完整 Endpoint ID；平台记录和对象存储不会因设备成功回执自动清理。": ["Data wipe and factory reset are destructive. Enter the full device ID. A successful device acknowledgement does not clear platform records or object storage.", "抹掉数据和恢复出厂设置会破坏设备数据。请输入完整设备 ID；平台记录和对象存储不会因设备成功回执自动清理。"],
  "确认 Endpoint ID": ["Confirm device ID", "确认设备 ID"],
  "请求抹掉数据": ["Request data wipe", "请求抹掉数据"],
  "请求恢复出厂": ["Request factory reset", "请求恢复出厂"],
  "刷新操作状态": ["Refresh operation", "刷新操作状态"],
  "本地演示成功回执": ["Demonstrate acknowledgement locally", "本地演示成功回执"],
  "data-wipe": ["Data wipe", "抹掉数据"],
  "endpoint.data_wipe": ["Data wipe", "抹掉数据"],
  "endpoint.factory_reset": ["Factory reset", "恢复出厂设置"],
  "factory-reset": ["Factory reset", "恢复出厂设置"],
  "数据": ["Data", "数据"],
  "按任务查看文件、异步媒体任务、诊断证据、连接质量和治理记录。": ["Browse files, media jobs, diagnostics, connection quality and governance records.", "按任务查看文件、异步媒体任务、诊断证据、连接质量和治理记录。"],
  "数据模块": ["Data modules", "数据模块"],
  "文件与下载": ["Files and downloads", "文件与下载"],
  "录制与广播": ["Recordings and broadcasts", "录制与广播"],
  "诊断证据": ["Diagnostics", "诊断证据"],
  "连接质量": ["Connection quality", "连接质量"],
  "审计与配额": ["Audit and quotas", "审计与配额"],
  "审计和配额已刷新": ["Audit and quotas refreshed", "审计和配额已刷新"],
  "配额已更新": ["Quota updated", "配额已更新"],
  "TURN usage 已上报": ["TURN usage reported", "中继用量已上报"],
  "配额与 TURN usage": ["Quotas and TURN usage", "配额与中继用量"],
  "Dimension": ["Quota dimension", "配额维度"],
  "Limit": ["Limit", "配额上限"],
  "Media node": ["Media node", "媒体节点"],
  "刷新": ["Refresh", "刷新"],
  "更新配额": ["Update quota", "更新配额"],
  "上报 TURN usage": ["Report TURN usage", "上报中继用量"],
  "审计事件": ["Audit events", "审计事件"],
  "ID": ["ID", "ID"],
  "Type": ["Type", "类型"],
  "Subject": ["Subject", "操作主体"],
  "Created": ["Created", "创建时间"],
  "暂无审计事件。": ["No audit events.", "暂无审计事件"],
  "任务列表已刷新": ["Jobs refreshed", "任务列表已刷新"],
  "录制已创建": ["Recording created", "录制已创建"],
  "广播已创建": ["Broadcast created", "广播已创建"],
  "已读取": ["Loaded", "已读取"],
  "确定停止选中的录制任务？": ["Stop the selected recording?", "确定停止选中的录制任务？"],
  "录制已停止": ["Recording stopped", "录制已停止"],
  "确定停止选中的广播任务？": ["Stop the selected broadcast?", "确定停止选中的广播任务？"],
  "广播已停止": ["Broadcast stopped", "广播已停止"],
  "任务输入": ["Job settings", "任务设置"],
  "Room ID": ["Room ID", "房间 ID"],
  "从直播页复制 Room ID": ["Copy the room ID from Live", "从直播页复制房间 ID"],
  "默认 Web Endpoint": ["Default Web Endpoint", "默认网页设备"],
  "Broadcast target URL": ["Broadcast destination URL", "广播目标地址"],
  "创建录制": ["Create recording", "创建录制"],
  "创建广播": ["Create broadcast", "创建广播"],
  "录制任务": ["Recordings", "录制任务"],
  "刷新任务": ["Refresh jobs", "刷新任务"],
  "暂无录制任务。": ["No recordings.", "暂无录制任务"],
  "查看详情": ["View details", "查看详情"],
  "停止录制": ["Stop recording", "停止录制"],
  "广播任务": ["Broadcasts", "广播任务"],
  "暂无广播任务。": ["No broadcasts.", "暂无广播任务"],
  "停止广播": ["Stop broadcast", "停止广播"],
  "邀请已重发，请复制新令牌": ["Invitation resent. Copy the new token.", "邀请已重发，请复制新令牌"],
  "邀请已重发": ["Invitation resent", "邀请已重发"],
  "邀请已撤销": ["Invitation revoked", "邀请已撤销"],
  "已发出的邀请": ["Sent invitations", "已发出的邀请"],
  "刷新邀请": ["Refresh invitations", "刷新邀请"],
  "暂无已发邀请。": ["No sent invitations.", "暂无已发邀请"],
  "重发邀请": ["Resend invitation", "重发邀请"],
  "撤销邀请": ["Revoke invitation", "撤销邀请"],
  "新邀请令牌（仅显示一次）": ["New invitation token (shown once)", "新邀请令牌（仅显示一次）"],
  "已复制邀请令牌": ["Invitation token copied", "已复制邀请令牌"],
  "复制令牌": ["Copy token", "复制令牌"],
  "Endpoint 状态已刷新": ["Device status refreshed", "设备状态已刷新"],
  "期望状态已更新": ["Desired state updated", "期望状态已更新"],
  "命令已创建": ["Command created", "命令已创建"],
  "此浏览器 Endpoint": ["This browser device", "此浏览器设备"],
  "刷新状态": ["Refresh status", "刷新状态"],
  "会话开始后自动绑定": ["Bound automatically when a session starts", "会话开始后自动绑定"],
  "类型": ["Type", "类型"],
  "状态": ["Status", "状态"],
  "版本": ["Version", "版本"],
  "Shadow desired": ["Desired device state", "设备期望状态"],
  "更新期望状态": ["Update desired state", "更新期望状态"],
  "Endpoint 命令": ["Device command", "设备命令"],
  "发送命令": ["Send command", "发送命令"],
  "访客": ["Guest", "访客"],
  "Runtime overview": ["Runtime overview", "运行概览"],
  "Check browser support, Platform reachability and the current public contract.": ["Check browser support and platform connectivity.", "检查浏览器支持与平台连接情况"],
  "Inspect runtime": ["Inspect runtime", "检查运行状态"],
  "OIDC issuer": ["OIDC issuer", "身份签发方"],
  "Browser data channel": ["Browser data channel", "浏览器数据通道"],
  "Screen capture": ["Screen capture", "屏幕采集"],
  "Media routes": ["Media routes", "媒体路由"],
  "Browser codecs": ["Browser codecs", "浏览器编码支持"],
  "No runtime codec information": ["No codec information", "暂无编码信息"],
  "Platform response": ["Platform response", "平台响应"],
  "Visible Domains": ["Visible spaces", "可见空间"],
  "Domain": ["Space", "空间"],
  "Status": ["Status", "状态"],
  "Owner": ["Owner", "所有者"],
  "No visible domains returned by the current App identity.": ["No spaces available.", "暂无可见空间"],
  "Identity and session": ["Identity and session", "身份与会话"],
  "The Demo consumes the Keycloak-managed session and never handles credentials.": ["Sessions are managed by Keycloak. The Demo never handles credentials.", "会话由 Keycloak 管理，Demo 不处理凭据。"],
  "Session facts": ["Session details", "会话详情"],
  "Client": ["Client", "客户端"],
  "Flow": ["Flow", "认证流程"],
  "Audience": ["Audience", "接收方"],
  "Expires": ["Expires", "到期时间"],
  "Projected profile": ["Account profile", "账号资料"],
  "Username": ["Username", "用户名"],
  "Email": ["Email", "邮箱"],
  "Email verified": ["Email verified", "邮箱已验证"],
  "Issuer": ["Issuer", "签发方"],
  "Identity boundary": ["Identity boundary", "身份管理边界"],
  "Passwords, MFA, refresh credentials and account lifecycle remain in Keycloak. Platform links the verified principal to product data using": ["Keycloak manages passwords, MFA and account lifecycle. The platform links identity to product data using", "密码、多因素认证和账户生命周期由 Keycloak 管理。平台通过以下标识关联身份与产品数据："],
  "Endpoint control": ["Device selection", "设备选择"],
  "查看当前空间可见的 Endpoint；默认 Web Endpoint 由 App Session 自动绑定。": ["View devices in this space. The default Web Endpoint is bound automatically by the App session.", "查看当前空间可见的设备；默认网页设备由应用会话自动绑定。"],
  "Refresh": ["Refresh", "刷新"],
  "Selected endpoint": ["Selected device", "当前设备"],
  "Endpoint inventory": ["Device list", "设备列表"],
  "No endpoint data loaded.": ["No devices loaded.", "暂无设备数据，请刷新列表"],
  "Version": ["Version", "版本"],
  "Media session": ["Media sessions", "媒体会话"],
  "Exercise room allocation, control-plane Session lifecycle and browser media runtime fencing.": ["Manage rooms, sessions and browser media connections.", "管理房间、会话与浏览器媒体连接"],
  "Load rooms and sessions": ["Load rooms and sessions", "加载房间和会话"],
  "Room and Session": ["Rooms and sessions", "房间与会话"],
  "Room name": ["Room name", "房间名称"],
  "Create room": ["Create room", "创建房间"],
  "Intent": ["Session purpose", "会话用途"],
  "conference": ["Conference", "会议"],
  "publish": ["Publish", "发布"],
  "watch": ["Watch", "观看"],
  "talk": ["Talk", "对讲"],
  "Create Session": ["Create session", "创建会话"],
  "Runtime controls": ["Connection controls", "连接控制"],
  "Connect": ["Connect", "连接"],
  "Capture": ["Capture", "采集"],
  "Publish": ["Publish", "发布"],
  "Resume": ["Resume", "恢复"],
  "Close": ["Close", "关闭"],
  "Local tracks": ["Local tracks", "本地轨道"],
  "Remote tracks": ["Remote tracks", "远端轨道"],
  "Route": ["Route", "路由"],
  "Rooms": ["Rooms", "房间列表"],
  "Name": ["Name", "名称"],
  "No rooms loaded.": ["No rooms loaded.", "暂无房间"],
  "Sessions": ["Sessions", "会话列表"],
  "Generation": ["Generation", "会话代次"],
  "No sessions loaded.": ["No sessions loaded.", "暂无会话"],
  "Storage transfers": ["File transfers", "文件传输"],
  "Verify presigned upload/download behavior without forwarding the Platform bearer token.": ["Upload and download files securely using temporary transfer links.", "通过临时传输链接安全地上传和下载文件"],
  "Refresh files": ["Refresh files", "刷新文件"],
  "Upload a disposable file": ["Upload a test file", "上传测试文件"],
  "Plan → direct PUT → completion confirmation.": ["Prepare upload → transfer file → confirm completion.", "准备上传 → 直传文件 → 确认完成"],
  "Choose file": ["Choose file", "选择文件"],
  "File inventory": ["Files", "文件列表"],
  "Bytes": ["Bytes", "字节数"],
  "No files loaded.": ["No files loaded.", "暂无文件"],
  "Download selected file": ["Download selected file", "下载选中文件"],
  "Download selected": ["Download selected", "下载选中文件"],
  "Delete selected file": ["Delete selected file", "删除选中文件"],
  "Delete selected": ["Delete selected", "删除选中文件"],
  "Selected:": ["Selected:", "已选中："],
  "Quality of Experience": ["Connection quality", "连接质量"],
  "Query the authorized report boundary and observe whether the current App identity has Domain content access.": ["Query connection quality reports for the current space.", "查询当前空间的连接质量报告"],
  "Query last hour": ["Query last hour", "查询最近一小时"],
  "Query controls": ["Query settings", "查询设置"],
  "Group by": ["Group by", "分组方式"],
  "event_type": ["Event type", "事件类型"],
  "route_mode": ["Route mode", "路由模式"],
  "browser_name": ["Browser", "浏览器"],
  "network_type": ["Network type", "网络类型"],
  "region": ["Region", "地区"],
  "QoE is intentionally queried through the public Domain contract. A 403 is a useful authorization result, not a UI failure.": ["Reports require permission for the current space. If access is denied, check your space role.", "报告需要当前空间的访问权限。如访问被拒绝，请检查空间角色。"],
  "Report": ["Report", "报告"],
  "诊断详情已刷新": ["Diagnostic details refreshed", "诊断详情已刷新"],
  "诊断已上传并完成": ["Diagnostic uploaded and completed", "诊断已上传并完成"],
  "诊断已标记失败": ["Diagnostic marked as failed", "诊断已标记失败"],
  "诊断已下载": ["Diagnostic downloaded", "诊断已下载"],
  "确定删除这份诊断证据？删除后平台将不再保留该归档。": ["Delete this diagnostic? The platform will no longer retain the archive.", "确定删除这份诊断证据？删除后平台将不再保留该归档。"],
  "诊断已删除": ["Diagnostic deleted", "诊断已删除"],
  "Endpoint diagnostics": ["Device diagnostics", "设备诊断"],
  "Request, upload, complete, inspect and remove bounded diagnostic evidence.": ["Request, upload, inspect and manage device diagnostic evidence.", "请求、上传、查看和管理设备诊断证据"],
  "Request diagnostic": ["Request diagnostic", "请求诊断"],
  "Diagnostic jobs": ["Diagnostic jobs", "诊断任务"],
  "Endpoint": ["Device", "设备"],
  "No diagnostic jobs loaded.": ["No diagnostics loaded.", "暂无诊断任务"],
  "上传并完成": ["Upload and complete", "上传并完成"],
  "标记失败": ["Mark as failed", "标记失败"],
  "下载": ["Download", "下载"],
  "删除": ["Delete", "删除"],
  "Boundary": ["Transfer security", "传输安全"],
  "Diagnostic uploads and downloads use short-lived direct plans. The Platform bearer token must never be sent to the object store.": ["Diagnostics use short-lived transfer links. Platform credentials are never sent to object storage.", "诊断文件使用短期有效的直传链接，不向对象存储发送平台凭据。"],
  "已复制可见日志": ["Visible logs copied", "已复制可见日志"],
  "复制失败，请检查浏览器剪贴板权限": ["Copy failed. Check clipboard permissions.", "复制失败，请检查浏览器剪贴板权限"],
  "Evidence": ["Evidence", "开发证据"],
  "Activity log": ["Activity log", "活动日志"],
  "提交中": ["Submitting", "提交中"],
  "提交日志": ["Submit logs", "提交日志"],
  "Copy": ["Copy", "复制"],
  "Clear": ["Clear", "清空"],
  "Actions and sanitized API outcomes will appear here.": ["Actions and sanitized API results appear here.", "这里显示操作记录及脱敏后的接口结果"],
  "not queried": ["Not queried", "尚未查询"],
  "query failed": ["Query failed", "查询失败"],
  "Available": ["Available", "可用"],
  "Unavailable": ["Unavailable", "不可用"],
  "Not inspected": ["Not inspected", "尚未检查"],
  "receive": ["Received", "接收"],
  "send": ["Sent", "发送"],
  "removeMembershipConfirm": ["Remove device membership from space {target}?", "确定移除设备对空间 {target} 的归属？"],
  "transferConfirm": ["Transfer this device from {source} to {target}?", "确定将设备从 {source} 转让到 {target}？"],
  "wipeConfirm": ["Run {kind} on device {id}? Device data may be unrecoverable. Platform copies are not cleared.", "确定对设备 {id} 执行{kind}？设备数据可能不可恢复，平台副本不会自动清理。"],
  "localAck": ["Local demonstration: {id} → succeeded. Server state remains {state}. Real acknowledgements require device identity; firmware and platform copy cleanup are unverified.", "本地模拟：{id} → 成功；服务端状态仍为{state}。真实回执必须由设备身份提交，固件和平台副本清理未验证。"],
  "revokeConfirm": ["Revoke the invitation to {email}? They can no longer use it to join the space.", "确定撤销发给 {email} 的邀请？对方将无法再使用该邀请加入空间。"],
  "deleteFileConfirm": ["Delete file {id}? It will be removed from the current space and unavailable to normal file flows.", "确定删除文件 {id}？文件将从当前空间移除，无法再通过常规流程访问。"],
  "closeSessionConfirm": ["Close session {id}? This disconnects the browser and ends the server session.", "确定关闭会话 {id}？浏览器连接和服务端会话都将结束。"],
  "countFiles": ["{count} file(s)", "共 {count} 个文件"],
  "countDevices": ["{count} device(s)", "共 {count} 台设备"],
  "countDiagnostics": ["{count} diagnostic(s)", "共 {count} 个诊断任务"],
  "lastHour": ["Last hour", "最近一小时"],
  "noPlan": ["No connection plan", "暂无连接计划"],
  "recordingDetails": ["Recording details", "录制详情"],
  "broadcastDetails": ["Broadcast details", "广播详情"],
  "roomSessionCount": ["{rooms} room(s), {sessions} session(s)", "共 {rooms} 个房间、{sessions} 个会话"],
  "trackCount": ["{count} local track(s)", "共 {count} 条本地轨道"],
  "generation": ["Generation {count}", "会话代次 {count}"],
} as const;

export type UiMessageKey = keyof typeof uiMessages;
export function uiMessage(locale: Locale, key: UiMessageKey, values?: Record<string, string | number>): string {
  const message: string = uiMessages[key][locale === "zh-CN" ? 1 : 0];
  return message.replace(/\{(\w+)\}/g, (token, name: string) => String(values?.[name] ?? token));
}
export function useUi() {
  const locale = useDemoStore((state) => state.locale);
  return useCallback((key: UiMessageKey, values?: Record<string, string | number>) => uiMessage(locale, key, values), [locale]);
}
// Translate known display enums only. Unknown protocol values remain available verbatim.
export function localizedValue(locale: Locale, value: unknown): string {
  const text = String(value ?? "-");
  return Object.prototype.hasOwnProperty.call(uiMessages, text) ? uiMessage(locale, text as UiMessageKey) : text;
}
export function useValueLabel() {
  const locale = useDemoStore((state) => state.locale);
  return (value: unknown) => localizedValue(locale, value);
}
